const appCommonActions = {
  GOOGLE_MAPS_LOAD_IN_PROGRESS: 'GOOGLE_MAPS_LOAD_IN_PROGRESS',
  GOOGLE_MAPS_LOADED_SUCCESS: 'GOOGLE_MAPS_LOADED_SUCCESS',
  GOOGLE_MAPS_LOADED_FAILURE: 'GOOGLE_MAPS_LOADED_FAILURE',

  googleMapsLoadInProg: ()=>({
    type: appCommonActions.GOOGLE_MAPS_LOAD_IN_PROGRESS
  }),

  googleMapsLoadedSuccess: ()=>({
    type: appCommonActions.GOOGLE_MAPS_LOADED_SUCCESS
  }),

  googleMapsLoadedFailure: () => ({
    type: appCommonActions.GOOGLE_MAPS_LOADED_FAILURE
  })
};

export default appCommonActions;